<template>
  <div class="d-flex flex-column flex-md-row justify-space-around my-5">
    <v-sheet
      @click="viewIncompleteStudents"
      rounded
      v-if="hasStudentPermission"
      class="pa-3 card ma-2 ma-md-0 text-center"
      :elevation="4"
    >
      {{ incompleteStudentCount }} Students Incomplete
    </v-sheet>
    <v-sheet
      @click="viewIncompleteStaff"
      rounded
      v-if="hasStaffPermission"
      class="pa-3 card ma-2 ma-md-0 text-center"
      :elevation="4"
    >
      {{ incompleteStaffCount }} Staff Incomplete
    </v-sheet>
    <v-sheet
      v-if="hasStudentPermission"
      @click="viewRecentStudentSubmissions"
      rounded
      class="pa-3 card ma-2 ma-md-0 text-center"
      :elevation="4"
    >
      {{ recentStudentSubmissionCount }} Recent Student Submissions
      <div class="text-caption text-center">Past 7 Days</div>
    </v-sheet>
    <v-dialog scrollable v-model="snapshotDialog" max-width="300px">
      <v-card>
        <v-card-title class="justify-space-between">
          <div>{{ snapshotTitle }}</div>
          <div>
            <v-btn @click="snapshotDialog = null" icon
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <keep-alive>
            <component v-bind:is="currentSnapshotComponent"></component>
          </keep-alive>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <router-link class="nostyle" :to="snapshotLink">View more...</router-link>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Role } from "@/router/_helper";
import moment from "moment";

export default {
  data: () => {
    return {
      incompleteStaffCount: 0,
      incompleteStaffList: [],
      incompleteStudentCount: 0,
      incompleteStudentList: [],
      recentStudentSubmissionCount: 0,
      recentStudentSubmissions: [],
      snapshotDialog: false,
      snapshotTitle: "",
      snapshotLink: null,
      currentSnapshotComponent: null
    };
  },
  mounted() {
    if(this.hasStudentPermission){
      this.getIncompleteStudents();
      this.getRecentStudentSubmissions();
    }
    if(this.hasStaffPermission){
      this.getIncompleteStaff();
      this.getRecentStaffSubmissions();
    }
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    hasStudentPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStudent) ||
        this.userRoles.includes(Role.Admin)
      );
    },
    hasStaffPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStaff) ||
        this.userRoles.includes(Role.Admin)
      );
    }
  },
  methods: {
    ...mapActions("student", ["fetchStudents"]),
    ...mapActions("staff", ["fetchStaff"]),
    ...mapActions("studentRequirementSubmission", [
      "fetchStudentRequirementSubmissions"
    ]),
    ...mapActions("staffRequirementSubmission", [
      "fetchStaffRequirementSubmissions"
    ]),
    getIncompleteStudents() {
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        activeOnly: true,
        allRequirementComplete: false
      };

      this.fetchStudents(params).then(response => {
        if (response) {
          this.incompleteStudentCount = response.totalElements;
          this.incompleteStudentList = response.content;
        }
      });
    },
    getIncompleteStaff() {
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        activeOnly: true,
        allRequirementComplete: false
      };

      this.fetchStaff(params).then(response => {
        if (response) {
          this.incompleteStaffCount = response.totalElements;
          this.incompleteStaffList = response.content;
        }
      });
    },
    getRecentStudentSubmissions() {
      const weekOld = moment().subtract(7, "days");
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        startDate: weekOld.format("YYYY-MM-DD")
      };
      this.fetchStudentRequirementSubmissions(params)
        .then(response => {
          if (response) {
            this.recentStudentSubmissionCount = response.totalElements;
            this.recentStudentSubmissions = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    getRecentStaffSubmissions() {
      const weekOld = moment().subtract(7, "days");
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        startDate: weekOld.format("YYYY-MM-DD")
      };
      this.fetchStaffRequirementSubmissions(params)
        .then(response => {
          if (response) {
            this.recentStaffSubmissionCount = response.totalElements;
            this.recentStaffSubmissions = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    viewIncompleteStudents() {
      if (this.incompleteStudentCount > 0) {
        this.snapshotDialog = true;
        this.snapshotTitle = "Incomplete Students";
        this.snapshotLink = {name: 'student'};
        const students = () =>
          import("@/components/snapshots/IncompleteStudents.vue");
        this.currentSnapshotComponent = students;
      }
    },
    viewIncompleteStaff() {
      if (this.incompleteStaffCount > 0) {
        this.snapshotDialog = true;
        this.snapshotTitle = "Incomplete Staff";
        this.snapshotLink = {name: 'staff'};
        const staff = () =>
          import("@/components/snapshots/IncompleteStaff.vue");
        this.currentSnapshotComponent = staff;
      }
    },
    viewRecentStudentSubmissions() {
      if (this.recentStudentSubmissionCount > 0) {
        this.snapshotDialog = true;
        this.snapshotTitle = "Recent Submissions";
        this.snapshotLink = {name: 'studentRequirementSubmission'};

        const recentStudents = () =>
          import("@/components/snapshots/RecentStudentSubmissions.vue");
        this.currentSnapshotComponent = recentStudents;
      }
    }
  }
};
</script>
<style scoped>
.card {
  cursor: pointer;
}
.nostyle{
  text-decoration: none;
}
</style>
